import { Retirement } from '../OverviewOPL/GoalCarousel/charts/Retirement/Retirement';
import EmergencyFundGoalChart from './EmergencyFundGoalChart/EmergencyFundGoalChartView';
import EducationGoalChart from './EducationGoalChart/EducationGoalContainer';
import LargePurchaseGoalChart from './LargePurchaseGoalChart/LargePurchaseGoalChartView';
import HomePurchaseGoalChart from './HomePurchaseGoalChart/HomePurchaseGoalChartView';
import HealthCareGoalChart from './HealthCareGoalChart/HealthCareGoalChartView';
import DebtManagementChart from './DebtManagement/DebtManagementGoalChart';

export default {
  retirement: {
    index: 0,
    chart: Retirement,
  },
  emergencyFund: {
    index: 1,
    chart: EmergencyFundGoalChart,
  },
  education: {
    index: 2,
    chart: EducationGoalChart,
  },
  largePurchase: {
    index: 3,
    chart: LargePurchaseGoalChart,
  },
  homePurchase: {
    index: 4,
    chart: HomePurchaseGoalChart,
  },
  healthCare: {
    index: 5,
    chart: HealthCareGoalChart,
  },
  debtManagement: {
    index: 6,
    chart: DebtManagementChart,
  },
};
